import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components/Link';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './Heading.scss';

class Heading extends React.Component {
  renderTitleLink = (path, name, spa, titleForGA, titleSuffix) =>
    path && !this.props.hideMoreBtn ? (
      <Link
        className="title"
        to={path}
        title={name}
        spa={spa}
        data-newga={titleForGA}
        onClick={e => {
          Heading.clickHandlerTitle(e);
        }}
      >
        {name}
        {titleSuffix ? <span className={s.suffix}>{titleSuffix}</span> : null}
      </Link>
    ) : (
      <>
        {name}
        {titleSuffix ? <span className={s.suffix}>{titleSuffix}</span> : null}
      </>
    );

  static clickHandleMore(e, name) {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: name,
      text: e?.target?.title,
      label: e?.target?.href,
      category: 'text clicked',
    });
  }

  static clickHandlerTitle(e) {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: e?.target?.title,
      text: e?.target?.title,
      label: e?.target?.href,
      category: 'text clicked',
    });
  }

  render() {
    const {
      name = '',
      path,
      titleSuffix,
      updatedPath,
      parentPath,
    } = this.props;
    const urlForMoreBtn = updatedPath || path;
    let spa = true;
    if (this.props.externalClick === 'true') {
      spa = false;
    }
    let moreTitle = 'More from ';
    moreTitle += name.charAt(0).toUpperCase() + name.slice(1);
    if (titleSuffix) {
      moreTitle += ` ${titleSuffix.charAt(0).toUpperCase() +
        titleSuffix.slice(1)}`;
    } else {
      moreTitle += ' Videos';
    }
    // let specialSliderTitle = '';
    // if (this.props.sliderBetweenList) {
    //   specialSliderTitle = 'special-slider-title';
    // }
    const headingClass = classNames({
      [`${s.header}`]: true,
      [`${s.clearfix}`]: true,
      [`${s['special-slider-title']}`]: this.props.sliderBetweenList,
      [`${s['links-list-title']}`]: this.props.linkslistData,
      [`${s['is-mobile']}`]: this.props.isWapView,
    });

    //Handling Google Analytics
    let actionForGA = `VideoSlider-${name}`;
    actionForGA += titleSuffix ? `_${titleSuffix}` : '';
    const titleForGA = `${actionForGA}#Section_View`;
    const moreBtnForGA = `${actionForGA}#Section_View_More`;

    let headingElem = name ? (
      <h2 className={s.heading1}>
        {this.renderTitleLink(path, name, spa, titleForGA, titleSuffix)}
        {this.props.customButtons}
      </h2>
    ) : (
      ''
    );
    if (this.props.headingType === 'h4') {
      if (this.props.isWapView) {
        headingElem = '';
      } else {
        headingElem = (
          <h4 className={s.heading1}>
            {this.renderTitleLink(path, name, spa, titleForGA, titleSuffix)}
          </h4>
        );
      }
    }
    if (this.props.headingType === 'h1') {
      if (this.props.isWapView) {
        headingElem = '';
      } else {
        headingElem = (
          <h1 className={s.heading1}>
            {this.renderTitleLink(path, name, spa, titleForGA, titleSuffix)}
          </h1>
        );
      }
    }
    return (
      <header className={headingClass}>
        {headingElem}
        {urlForMoreBtn &&
        urlForMoreBtn !== parentPath &&
        !this.props.hideMoreBtn &&
        !this.props.isWapView ? (
          <Link
            className={s['more-btn']}
            to={urlForMoreBtn}
            title={moreTitle}
            spa={spa}
            data-newga={moreBtnForGA}
            onClick={e => {
              Heading.clickHandleMore(e, this.props.name);
            }}
          >
            View more {name} videos
          </Link>
        ) : (
          ''
        )}
      </header>
    );
  }
}

Heading.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string,
  titleSuffix: PropTypes.string,
  hideMoreBtn: PropTypes.bool,
  updatedPath: PropTypes.string,
  parentPath: PropTypes.string,
  externalClick: PropTypes.string,
  sliderBetweenList: PropTypes.bool,
  isWapView: PropTypes.bool,
  linkslistData: PropTypes.bool,
  headingType: PropTypes.string,
  customButtons: PropTypes.shape({}),
};

Heading.defaultProps = {
  path: undefined,
  parentPath: '',
  titleSuffix: '',
  hideMoreBtn: false,
  externalClick: 'false',
  sliderBetweenList: false,
  isWapView: false,
  linkslistData: false,
  headingType: 'h2',
  customButtons: undefined,
  updatedPath: '',
};

export default Heading;
